export default __webpack_public_path__ + "static/media/ProteinBanner.ea4d6f10.png";